import { Lock } from 'lucide-react'

import { DiagnosticCopy } from '@krp/ui-kit'

import type { ActionVm } from '../model/types'

/** Почему действие недоступно — значком и словами, не цветом и не пустой кнопкой (R2 карточки UA1). */
export function ActionReason({ action }: { action: ActionVm }) {
  if (action.allowed || action.reason === null) return null
  return (
    <p className="platform-action-reason">
      <Lock size={14} aria-hidden="true" /> <span>{action.reason}</span>
    </p>
  )
}

/** Ошибка команды: текст сервера дословно (ADR-8), код и корреляция — для отчёта; «Копировать» берёт её целиком. */
export function CommandError({ error }: { error: { message: string; code: string; correlationId: string | null } | null }) {
  if (error === null) return null
  const report = [error.message, `Код: ${error.code}`, ...(error.correlationId !== null ? [`Запрос: ${error.correlationId}`] : [])].join('\n')
  return (
    <div role="alert" className="platform-command-error">
      <strong>Не выполнено.</strong> <span>{error.message}</span>
      <small>
        {' '}
        Код: {error.code}
        {error.correlationId !== null ? ` · запрос ${error.correlationId}` : ''}
      </small>
      <DiagnosticCopy text={report} label="Копировать" />
    </div>
  )
}
